import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ListCreationError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ListCreationError;
  createList(request: Boundaries["createList"]["request"]): void;
}

function useListCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isListCreationRequestPending),
    isRequestSuccess: useSelector(selector.isListCreationRequestSuccess),
    isRequestFailure: useSelector(selector.isListCreationRequestFailure),
    error: useSelector(selector.getListCreationError),
    createList: core.createList,
  };
}

export { useListCreation };
